import { useCallback, useEffect, useState } from "react";
import type { ComponentType, ReactNode } from "react";
import { PUBLIC_SIGN_IN_EVENT } from "./public-auth-modal";

type PublicSignInDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

type PublicSignInDialogComponent = ComponentType<PublicSignInDialogProps>;

let publicSignInDialogPromise: Promise<{
  PublicSignInDialog: PublicSignInDialogComponent;
}> | null = null;

function loadPublicSignInDialog() {
  publicSignInDialogPromise ??= import("@/components/layout/PublicSignInDialog");
  return publicSignInDialogPromise;
}

export function PublicAuthModalProvider({ children }: { children: ReactNode }) {
  const [isSignInOpen, setIsSignInOpen] = useState(false);
  const [SignInDialog, setSignInDialog] = useState<PublicSignInDialogComponent | null>(null);

  const openSignIn = useCallback(() => {
    setIsSignInOpen(true);
    void loadPublicSignInDialog().then((module) => {
      setSignInDialog(() => module.PublicSignInDialog);
    });
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;

    window.addEventListener(PUBLIC_SIGN_IN_EVENT, openSignIn);
    return () => window.removeEventListener(PUBLIC_SIGN_IN_EVENT, openSignIn);
  }, [openSignIn]);

  return (
    <>
      {children}
      {SignInDialog && isSignInOpen && (
        <SignInDialog open={isSignInOpen} onOpenChange={setIsSignInOpen} />
      )}
    </>
  );
}
